import { mapState, mapActions, mapMutations, mapGetters } from 'vuex';
import actions from './actions';
import state from './state';
import mutations from './mutations';
import getters from './getters';

export const serviceComputed = {
	...mapState('pcIdxNum3MStore', Object.keys(state)), // store에서 사용할 변수는 유일해야되기 때문에 이름을 바꾼다.
	...mapGetters('pcIdxNum3MStore', Object.keys(getters)) // store에서 사용할 변수는 유일해야되기 때문에 이름을 바꾼다.
};
export const serviceMethods = {
	...mapActions('pcIdxNum3MStore', Object.keys(actions)), // store에서 사용할 변수는 유일해야되기 때문에 이름을 바꾼다.
	...mapMutations('pcIdxNum3MStore', Object.keys(mutations)) // store에서 사용할 변수는 유일해야되기 때문에 이름을 바꾼다.
};
